import { MFA_TYPE } from '@common/types';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import {
  Box,
  Button,
  Paper,
  SelectChangeEvent,
  Typography,
} from '@mui/material';
import { useContext } from 'react';
import { MFAContext } from './context';
import { Select } from 'ui';

export const MFAChooseMethod = () => {
  const { goToNextStep, mfaType, setMFAType } = useContext(MFAContext);

  const handleChange = (e: SelectChangeEvent) => {
    const value = e.target.value as MFA_TYPE;
    setMFAType(value);
  };

  const mfaOptions = [
    {
      value: MFA_TYPE.APP,
      label: 'Authentication app',
    },
    {
      value: MFA_TYPE.SMS,
      label: 'Phone (SMS)',
    },
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '3.5rem',
        width: '28rem',
        height: '100%',
      }}
    >
      <Paper
        elevation={8}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '1.5rem',
          gap: '32px',
          width: '100%',
          borderRadius: 0,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '16px',
            padding: 0,
          }}
        >
          <VerifiedUserIcon sx={{ fontSize: '3rem' }} color='primary' />
          <Typography
            sx={{ fontWeight: '600', fontSize: '1.5rem', color: 'primary' }}
          >
            Protect your account with MFA
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography
            sx={{
              paddingY: '24px',
              fontSize: '16px',
              lineHeight: '24px',
              fontWeight: '400',
              textAlign: 'center',
            }}
          >
            Multi-factor authentication (MFA) adds an extra layer of security to
            your account. Please select your default authentication method to
            secure your account.
          </Typography>
        </Box>

        <Box sx={{ width: '100%' }}>
          <Select
            name='mfa-type'
            label='Select authentication method'
            value={mfaType}
            onChange={handleChange}
            options={mfaOptions}
            clearable={false}
          />
        </Box>

        <Button
          variant='contained'
          type='submit'
          color='secondary'
          sx={{ color: 'white', padding: '0.5rem', fontWeight: '500' }}
          onClick={goToNextStep}
          fullWidth
        >
          CONTINUE
        </Button>
      </Paper>
    </Box>
  );
};
